// packages import
import { Avatar, List, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";
import moment from "moment";
import { useContext } from "react";
// component import
import { CustomModal } from "../../common/CustomModal";
// others
import { AppContext } from "../../../context";
import { ActionType, } from "../../../context/AppContextReducer";

export const CalenderEventModal = () => {
  const { isOpen, dispatch, currentEvent } = useContext(AppContext);
  const { title, start, attendees, end, organizer } = currentEvent || {}
  const eventDate = moment(start).format('dddd, MMMM DD, YYYY')
  const startTime = moment(start).format('hh:mm a')
  const endTime = moment(end).format('hh:mm a')
  const dateTime = `${eventDate}    ${startTime} - ${endTime}`
  const { emailAddress: organizerEmailAddress } = organizer || {}
  const { address: organizerEmail } = organizerEmailAddress || {}
  const organizerDetail = `${organizerEmail} - Organizer`

  const handleClose = () => dispatch({ type: ActionType.SET_IS_OPEN, isOpen: !isOpen })

  return (
    <CustomModal title="Event Detail" isOpen={isOpen} handleClose={handleClose}>
      <Typography fontSize='20px'>{title}</Typography>

      <Typography fontSize='16px'>{dateTime}</Typography>

      <Typography fontSize='16px' mt={3} fontWeight='500'>Attendees</Typography>

      <List>
        <ListItem key={organizerDetail} sx={{ paddingInline: 0, paddingBlock: 0.5 }}>
          <ListItemIcon sx={{ width: 28, height: 28, minWidth: '44px' }}>
            <Avatar sx={{ width: 24, height: 24 }} />
          </ListItemIcon>

          <ListItemText
            primary={organizerDetail}
            primaryTypographyProps={{
              fontSize: '14px'
            }}
          />
        </ListItem>

        {attendees?.map((attendee, index) => {
          const { emailAddress } = attendee || {}
          const { address } = emailAddress || {}

          return (
            <ListItem key={`${index}-address`} sx={{ paddingInline: 0, paddingBlock: 0.5 }}>
              <ListItemIcon sx={{ width: 28, height: 28, minWidth: '44px' }}>
                <Avatar sx={{ width: 24, height: 24 }} />
              </ListItemIcon>

              <ListItemText
                primary={address}
                primaryTypographyProps={{
                  fontSize: '14px'
                }}
              />
            </ListItem>
          )
        })}
      </List>
    </CustomModal>
  )
}
